<template>
    <div class="relative">
        <Combobox v-model="selected" @update:modelValue="onSelect" v-slot="{ open }">
            <ComboboxInput
                autocomplete="off"
                class="p-4 rounded-md bg-ivory text-black flex items-center w-full outline-0"
                :class="{ 'rounded-b-none': open }"
                placeholder="Search"
                @change="query = $event.target.value"
                :displayValue="(item) => item.post_title"
            />
            <ComboboxOptions
                v-if="filteredItems.length"
                class="z-50 absolute max-h-64 overflow-hidden top-full left-0 w-full shadow-xl rounded-b-md bg-white divide-y divide-sand-light"
            >
                <ComboboxOption
                    v-for="item in filteredItems"
                    :key="item.ID"
                    :value="item"
                    class="p-4 text-black grid cursor-pointer ui-active:bg-sand"
                >
                    <div class="inline-flex gap-2 flex-wrap items-center">
                        <span class="font-header uppercase text-md leading-none">{{ item.post_title }}</span>
                        <span v-if="item.event_is_sold_out" class="bg-red size-2 block rotate-45 mb-2"></span>
                    </div>
                    <span class="font-bold">{{ item.event_start_date }}</span>
                </ComboboxOption>
            </ComboboxOptions>
        </Combobox>

        <div class="absolute text-black right-4 top-1/2 -translate-y-1/2" aria-hidden="true">
            <div class="size-8 cursor-pointer">
                <svg class="size-8" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="14.7692" cy="14.7692" r="12.7692" stroke="currentColor" stroke-width="4"></circle>
                    <path
                        d="M34.5856 37.4142C35.3666 38.1953 36.6329 38.1953 37.414 37.4142C38.195 36.6332 38.195 35.3669 37.414 34.5858L35.9998 36L34.5856 37.4142ZM24.9229 24.9231L23.5086 26.3373L34.5856 37.4142L35.9998 36L37.414 34.5858L26.3371 23.5089L24.9229 24.9231Z"
                        fill="currentColor"
                    ></path>
                </svg>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from "vue";
import Fuse from "fuse.js";
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from "@headlessui/vue";

const props = defineProps({
    items: {
        type: Array,
        required: true,
    },
    isLoading: {
        type: Boolean,
        required: true,
    },
});

const query = ref("");
const selected = ref([]);

const fuse = computed(() => {
    return new Fuse(props.items, {
        keys: ["post_title", "post_excerpt"], // search in both fields
        threshold: 0.4, // adjust fuzziness (0 exact → 1 very fuzzy)
        includeScore: true,
    });
});

const filteredItems = computed(() => {
    if (!query.value) return [];
    return fuse.value
        .search(query.value)
        .map((r) => r.item)
        .slice(0, 10);
});

function onSelect(item) {
    if (item?.permalink) {
        window.location.href = item.permalink;
    }
}
</script>
